import { CommonService } from './../../../service/common.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpService } from 'src/app/service/http.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  isIframe = false;
  private readonly _destroying$ = new Subject();
  isAutoLogin: boolean = true;

  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private router: Router,
    private httpService: HttpService,
  ) {
    this.isAutoLogin = this.router.url.includes('login');
  }

  ngOnInit(): void {
    const userData = JSON.parse(this.httpService.localStorageGetItem('admin_user'));
    const params = this.router.parseUrl(this.router.url).queryParams;
    if (this.commonService.handleOAuthError(params)) {
      return;
    }
    this.isIframe = window !== window.parent && !window.opener;
    if (this.router.url.includes('logout') && userData && userData['role'] === 'companyadmin') {
      this.httpService.localStorageClear();
      window.open(environment.appRedirectUri, '_self');
      return;
    }
    
    this.authService.initSSOLogin();
    const authCode = params['code'];
    if (authCode) {
      const payload = {
        authCode: authCode,
        redirectURL: environment.redirectUri,
        pkceVerifier: localStorage.getItem('PKCE_verifier')
      };
      this.handleAdminSSO(payload);
      return;
    }

    if (this.isAutoLogin) {
      this.authService.SSOLogin();
    }
  }

  handleAdminSSO(payload: any) {
    this.authService.adminSsoLogin(payload).pipe(takeUntil(this._destroying$)).subscribe({
      next: (data) => {
        if (data['user']) {
          data["user"] = JSON.parse(this.commonService.decrypt(data['user']));
        }
        this.httpService.sessionStorageSetItem('admin_role', data['user']['role']);
        this.httpService.localStorageSetItem('admin_user', JSON.stringify(data['user']));
        this.httpService.localStorageSetItem('admin_token', data['accessToken']);
        this.httpService.localStorageSetItem('refreshToken', data['refreshToken']);
        this.router.navigate(['/dashboard']);
      },
      error: (err) => {
        this.httpService.apiErrorHandler(err, 'error', true, 'Login Failed');
      }
    });
  }

  manualLogin() {
    this.authService.initSSOLogin();
    this.authService.SSOLogin();
  }

  ngOnDestroy(): void {
    this._destroying$.next(null);
    this._destroying$.complete();
  }
}
